module.exports = __webpack_public_path__ + "static/media/ram-crop.abc34963.png";